import { normalizeApiError } from '../api/apiError';

const MESSAGES: Record<string, string> = {
  ORGANIZATION_NOT_FOUND: 'Organization was not found.',
  ORGANIZATION_UPDATE_NOT_ALLOWED: 'Organization details cannot be updated.',
  LOCATION_NOT_FOUND: 'Location was not found.',
  LOCATION_CODE_EXISTS: 'A location with this code already exists.',
  LOCATION_NAME_EXISTS: 'A location with this name already exists.',
  DEPARTMENT_NOT_FOUND: 'Department was not found.',
  DEPARTMENT_CODE_EXISTS: 'A department with this code already exists.',
  DEPARTMENT_PARENT_INVALID: 'The selected parent department is invalid.',
  DEPARTMENT_HIERARCHY_CYCLE:
    'This parent selection would create an invalid hierarchy.',
  DESIGNATION_NOT_FOUND: 'Designation was not found.',
  DESIGNATION_CODE_EXISTS: 'A designation with this code already exists.',
  TEAM_NOT_FOUND: 'Team was not found.',
  TEAM_CODE_EXISTS: 'A team with this code already exists.',
  TEAM_DEPARTMENT_INVALID: 'The selected department is invalid.',
  TEAM_LEAD_INVALID: 'The selected team lead is invalid.',
  VERSION_CONFLICT:
    'This record was updated by another user. Reloading the latest information.',
  ROW_VERSION_MISMATCH:
    'This record was updated by another user. Reloading the latest information.',
  RECORD_MODIFIED:
    'This record was updated by another user. Reloading the latest information.',
  CONCURRENT_UPDATE:
    'This record was updated by another user. Reloading the latest information.',
  VALIDATION_ERROR: 'Check the entered information.',
  ACCESS_DENIED: 'You do not have permission to perform this action.',
  BUSINESS_RULE_ERROR: 'The server rejected this change.',
  NETWORK_ERROR: 'Unable to connect to the server.',
  REQUEST_TIMEOUT: 'The server took too long to respond.',
};

export function isConcurrencyConflict(error: unknown): boolean {
  const code = readErrorCode(error);
  return (
    code === 'VERSION_CONFLICT' ||
    code === 'ROW_VERSION_MISMATCH' ||
    code === 'RECORD_MODIFIED' ||
    code === 'CONCURRENT_UPDATE'
  );
}

export function organizationErrorMessage(
  error: unknown,
  fallback = 'Unable to load organization information.',
): string {
  const code = readErrorCode(error);
  if (code && MESSAGES[code]) return MESSAGES[code];

  const apiError = normalizeApiError(error);
  if (apiError.code && MESSAGES[apiError.code]) {
    return MESSAGES[apiError.code];
  }
  return fallback;
}

function readErrorCode(error: unknown): string | null {
  if (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    typeof (error as { code?: unknown }).code === 'string'
  ) {
    return (error as { code: string }).code;
  }
  return null;
}
